const cambiarIdioma = objeto => {
    return {
        type: 'cambiarIdioma',
        payload: objeto
    }
}

module.exports = {
    cambiarIdioma
}